import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  ItemContainer,
  ImageComtainer,
  ImageTagContainer,
  ImageTag,
  InfoComtainer,
  InfoTitle,
  FoldMoreContainer,
  FoldMoreTitleComtainer,
  InfoPrice,
  InfoPriceTag,
  InfoPriceNum,
  InfoDetail,
  InfoDetailVisit,
  InfoDetailLine,
  InfoDetailLoc,
  InfoTime,
  InfoTimeTag,
  InfoTimeDesc,
  FoldComtainer,
  FoldTitleComtainer,
  ItemContainerBody,
  FoldTitleText,
  FoldTitleNum,
  FoldImgComtainer,
  FoldBtn
} from './style';

import PriceItem from './PriceItem';
import Detail from './Detail';
import Time from './Time';
import unit_institution from "../../../store/asset_institution/unit_institution";
import { webviewRedirect,MpingClick,getBusinessTypeByMP, getUrlParms } from '../../../utils/tool'

class AuctionItem extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {

  }

  gotoItemPage(paimaiId,index) {
    // 跳转资产单品页同时写入缓存
    const {setAssetTargetData,setTabIndex} = unit_institution;
    setAssetTargetData();
    setTabIndex();
    MpingClick("Auction_ProductList",JSON.stringify({business_type:getBusinessTypeByMP(),sort:index}))
    // 跳转到单品页
    webviewRedirect(`//mpaimai.jd.com/${paimaiId}`)
  }

  getImageTag() {
    const {itemInfo} = this.props;
    const supportLoan = itemInfo && itemInfo.loan === 1;
    if (supportLoan || itemInfo.purchaseRestriction) {
      return (
        <ImageTagContainer>
          {
            supportLoan && <ImageTag
              bgColor={'#e3874c'}
              color={'#ffffff'}
            >可贷款</ImageTag>
          }
          {
            itemInfo.purchaseRestriction==1 && <ImageTag
              bgColor={'#f6e38b'}
              color={'#a55300'}
            >不限购</ImageTag>
          }
        </ImageTagContainer>
      );
    }
    return null;
  }

  render() {
    const {itemInfo, realTimeData,index} = this.props;
    return (
      <ItemContainerBody>
        <ItemContainer className="auction-item" onClick={() => {
          this.gotoItemPage(itemInfo.id,index);
        }} data-paimaiid={itemInfo.id}>
          <ImageComtainer>
            {
              this.getImageTag()
            }
            <img src={`//img1${itemInfo.id % 5}.360buyimg.com/imgw/s480x320_${itemInfo.productImage}!cc_3x2!q85`}></img>
          </ImageComtainer>
          <InfoComtainer>
            <InfoTitle>{itemInfo.title}</InfoTitle>
            <PriceItem
              realTimeData={realTimeData}
              itemInfo={itemInfo}></PriceItem>
            <Detail
              realTimeData={realTimeData}
              itemInfo={itemInfo}></Detail>
            <Time
              realTimeData={realTimeData}
              itemInfo={itemInfo}
            ></Time>
          </InfoComtainer>
        </ItemContainer>
      </ItemContainerBody>
    )
  }
}

export default AuctionItem;
